/**
 * Application Header Component
 *
 * Displays the Sanctum logo/name and user dropdown menu.
 * Shows login button when not authenticated.
 */

import { type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, LoginButton } from '@features/auth';
import { ROUTES } from '@utils/constants';
import { visibleSections } from '@utils/navigation';
import { UserDropdown } from './UserDropdown';
import './Header.css';

export function Header(): ReactElement {
  const { user, oauthEnabled, isAuthenticated, isAdmin } = useAuth();

  return (
    <header className="app-header">
      <div className="app-header__container">
        <div className="app-header__left">
          <Link to={ROUTES.HOME} className="app-header__brand">
            Sanctum
          </Link>

          {user && (
            <nav className="app-header__nav" aria-label="Main navigation">
              {visibleSections(isAdmin).map((section) => (
                <Link key={section.to} to={section.to} className="app-header__nav-link">
                  {section.label}
                </Link>
              ))}
            </nav>
          )}
        </div>

        {user ? (
          <UserDropdown
            displayName={user.name || user.email}
            showLogout={oauthEnabled}
          />
        ) : (
          oauthEnabled &&
          !isAuthenticated && <LoginButton className="app-header__login" />
        )}
      </div>
    </header>
  );
}
